import { IMappingProfile, PFWmsEntities } from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMetadata,
    withMetadata,
} from '@pf/shared-utility';
import {
    ProjectLineItemCreate,
    ProjectLineItemDto,
    ProjectLineItemRead,
    ProjectLineItemSearchParams,
} from '../../entities/project-line-item.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.ProjectLineItem);

withDefaultEntityMetadata<ProjectLineItemDto>(symbols.dto, {
    customFields: CustomFieldMetadataMap.symbols.dto,
    endDate: String,
    item: [Object],
    lineNumber: Number,
    notes: String,
    pick: [Object],
    projectId: String,
    quantity: Number,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    status: String,
    unitOfMeasure: String,
});

withDefaultEntityMetadata<ProjectLineItemRead>(symbols.entity, {
    customFields: CustomFieldMetadataMap.symbols.entity,
    endDate: String,
    item: [Object],
    lineNumber: Number,
    notes: String,
    pick: [Object],
    quantity: Number,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    status: String,
    unitOfMeasure: String,
    project: [Object],
});

withMetadata<ProjectLineItemCreate>(symbols.createBody, {
    endDate: String,
    itemId: String,
    lineNumber: Number,
    notes: String,
    pickId: String,
    projectId: String,
    quantity: Number,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    status: String,
    unitOfMeasure: String,
});

withDefaultSearchParamsMetadata<ProjectLineItemSearchParams>(
    symbols.searchParams,
    {
        startDateRangeStart: String,
        startDateRangeEnd: String,
        endDateRangeStart: String,
        endDateRangeEnd: String,
        status: String,
        projectId: String,
        lineNumber: Number,
        itemId: String,
        packLineId: String,
    }
);

export const ProjectLineItemMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<ProjectLineItemRead, ProjectLineItemDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<ProjectLineItemDto, ProjectLineItemRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<ProjectLineItemDto, ProjectLineItemCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
    },
};
